<template>
  <div class="space-table" :class="{'is--indented': indented}">
    <div v-if="data.title" class="space-table--title">
      {{ data.title }}
    </div>
    <div v-if="data.description" class="space-table--description">
      <p v-html="data.description"></p>
      <p v-if="data.allows_discount">{{ data.exclaimer }}</p>

    </div>
    <ul class="space-table--list">
      <li v-for="item in data.values" v-bind:key="item.name">
        <div class="space-table--name">{{ item.name }}</div>
        <div class="space-table--value">{{ item.value }}</div>
      </li>
    </ul>
    <p v-if="org_name == 'Nhood'">Consejos para reservar​<br><br>

      Reservas de más de 3 días: Aprovecha nuestras tarifas semanales con descuento al reservar por más de 3 días consecutivos.​
      <br><br>
      Reservas de más de 6 meses: Para estancias prolongadas, te recomendamos contactarnos directamente para acceder a condiciones especiales y beneficios adicionales.​
      <br><br>
      ​
      Precios con impuestos no incluidos.</p>
  </div>
</template>

<script>
export default {
  name: 'SpacesTable',
  data: () => ({
  }),
  props: ['data', 'indented', 'org_name'],
  components: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-table {
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
  width: 100%;

  &.is--indented {
    .space-table--list {
      padding: 0 10vw;
    }
  }
}
.space-table--title {
  width: 100%;
  display: block;
  @include responsive-text-size('Header--13--BOLD');
  padding-bottom: 16px;
  margin-bottom: 19px;
  border-bottom: 1px solid $divider-dark;
}
.space-table--description {
  width: 100%;
  display: block;
}
.space-table--list {
  list-style: none;
  padding: 0;
  li {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-top: 1px solid $divider-light;
    padding: 5px 0;
    &:first-child {
      border-top: 0px;
    }
    &:last-child {
      border-bottom: 1px solid $divider-light;
    }
  }
}
.space-table--value {
  text-align: right;
}
</style>
